import { useDispatch } from 'react-redux'
import { authoriseError } from '../redux/slice/paymentResponseSlice'

export default function useAuthoriseError() {
  const dispatch = useDispatch()
  const handleError = (responseStatus, responseData) => {
    dispatch(
      authoriseError({
        responseStatus,
        errorCode: responseData?.errorCode,
        errorMessage: responseData?.errorMessage,
        isRetryable: responseData?.isRetryable,
      }),
    )
  }

  return handleError
}
